<script>
export default {
  props: {
    value: String,
  },

  computed: {
    /**
     * @return {boolean}
     */
    isEmpty() {
      return !Boolean(this.value);
    },

    displayText() {
      return this.value || 'Add a note ...';
    },
  },

  methods: {},
}
</script>
